export const API_URL =
  process.env.REACT_APP_API_URL || 'https://dt-test-api.kapsarc.org/api'; // || 'https://dt-intranet.onrender.com/api';
export const API_KEY = process.env.REACT_APP_API_KEY || 'foo';
